import {formatZonedDateTime} from "@/baseUtils";

export class EntityVersion {

    constructor(data) {
        this.id = data.id;
        this.version = data.version;
        this.header = data.header;
        this.status = data.status; // VersionedEntityStatus
        this.changeType = data.changeType; // EntityChangeType
        this.createDateTime = formatZonedDateTime(data.createDateTime);
    }
}